import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  Router,
  NavigationEnd,
  NavigationStart,
  ActivatedRoute,
} from "@angular/router";
import { APPCONFIG } from "./config";
import { LayoutService } from "./layout/layout.service";
import { AuthService } from "angularx-social-login";
import { HttpService } from "./shared/services/http.service";
import { SessionHandler } from "./shared/services/session-handler.service";

import { TranslateService } from "@ngx-translate/core";

// 3rd
import "styles/font-awesome.scss";
import "styles/material2-theme.scss";
import "styles/bootstrap.scss";
// custom
import "styles/layout.scss";
import "styles/theme.scss";
import "styles/ui.scss";
import "styles/app.scss";
import { CommonService } from "./shared/services/common.service";

@Component({
  selector: "app-root",
  template: require('./app.component.html'),
  providers: [LayoutService, HttpService, SessionHandler],
})
export class AppComponent {
  AppConfig: any;
  initParam: any;
  flag: boolean = true;
  constructor(
    private router: Router,
    public translate: TranslateService,
    private authService: AuthService,
    public httpService: HttpService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.authService.authState.subscribe((user) => {
          if (user == null && this.router.url.indexOf("login") < 0) {
            if (this.initParam != undefined && this.initParam != "") {
              localStorage.setItem("initParam", this.initParam);
            }
            console.log(this.router.url);
            if (
              this.router.url.indexOf("extra/upload") < 0 &&
              this.router.url.indexOf("extra/fileDownload") < 0 &&
              this.router.url.indexOf("/extra/fileDirectory") < 0
            ) {
              this.commonService.navigateToLogin();
            }
          }
        });
      }
    });
    localStorage.removeItem("selectedValue");
    //translate.setDefaultLang('en');
    translate.use("en");
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.flag = false;
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      document.body.scrollTop = 0;
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts